export const app_background = "#f2f6f8";
export const white = "#fff";
export const black = "#000";
export const midnightBack = "#0c0033";
export const indigo = "#5e23ff";

export const green = "#00c221";
export const lightGreen = "#00ff00";
export const darkgreen = "#00a11b";

export const purple = "#a585fc";
export const lightPurple = "#99ccff";

export const alert = "#ff0048";
export const darkGrey = "#4d5a70";
export const lightGray = "#C6D5DE";
export const disable = "#bdb9c6";
export const ultralight = "#e5edf1";
export const gray = "#817B95";
export const yellow = "#FFE100";